import { useTranslation } from "react-i18next";

import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Stack } from "@mui/material";
import { FormikProps } from "formik";

import { AssetRelativesFormValues } from "../../RelativesView.types";
import { DependantFields } from "../dependant-fields/DependantFields";

interface Props {
  formik: FormikProps<AssetRelativesFormValues>;
  index: number;
  onRemove: () => void;
}

export function DependantCard({ formik, index, onRemove }: Props) {
  const { t } = useTranslation();
  const section = "clients.client.debtSettlement.assetInventory.dependants";
  const base = `dependants.${index}` as const;
  const dependant = formik.values.dependants[index];

  if (!dependant) {
    return null;
  }

  return (
    <Stack gap={2} sx={{ p: 2, borderRadius: 1, border: (theme) => `4px solid ${theme.palette.fsw["blue-10"]}` }}>
      <DependantFields formik={formik} base={base} dependant={dependant} />
      <Button variant="text" startIcon={<DeleteIcon />} onClick={onRemove} sx={{ alignSelf: "flex-end" }}>
        {t(`${section}.removeDependant`)}
      </Button>
    </Stack>
  );
}
